import { render, staticRenderFns } from "./dialog-input.vue?vue&type=template&id=12672504&"
import script from "./dialog-input.vue?vue&type=script&lang=js&"
export * from "./dialog-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports